import React from "react";
import instagramLogo from "assets/svg/instagram-logo.svg";
import linkedinLogo from "assets/svg/linkedin-logo.svg";
import youtubeLogo from "assets/svg/youtube-logo.svg";
import Select from "components/Select/index";
import Textarea from "components/TextArea/index";
import SwitchInput from "components/Toggles/Switch/index.jsx";
import {
  EditCreatorFormWrapperStyles,
  CreatorPlatformsWrapperStyles
} from "../styled";
import { contentQualityOptions } from "pages/Creators/data";

const PLATFORMS = [
  {
    logo: instagramLogo,
    alt: "Instagram Logo",
    handleKey: "ig_handle",
    nameKey: "ig_name",
    nameLabel: "Instagram Name",
    countKey: "ig_followers",
    countLabel: "Instagram Followers"
  },
  {
    logo: youtubeLogo,
    alt: "YouTube Logo",
    handleKey: "yt_handle",
    nameKey: "yt_channel_name",
    nameLabel: "YouTube Channel Name",
    countKey: "yt_subscribers",
    countLabel: "YouTube Subscribers"
  },
  {
    logo: linkedinLogo,
    alt: "LinkedIn Logo",
    nameKey: "ln_profile",
    nameLabel: "LinkedIn Profile",
    countKey: "ln_followers",
    countLabel: "LinkedIn Followers"
  }
];

export const CreatorPlatformsSection = ({ form, setForm, handleChange }) => {
  return (
    <EditCreatorFormWrapperStyles>
      <div className="form-header-wrapper">
        <h2 className="title">Creator Platforms</h2>
      </div>

      <div className="form-content-wrapper">
        <div className="row-group">
          {/* ── Platform list (read-only) ── */}
          <div className="column-group">
            <CreatorPlatformsWrapperStyles>
              <div className="main-content">
                <div className="platform-list">
                  {PLATFORMS?.map(
                    ({
                      logo,
                      alt,
                      nameKey,
                      handleKey,
                      nameLabel,
                      countKey,
                      countLabel
                    }) => (
                      <div key={nameKey} className="platform-list-item">
                        <div className="icon">
                          <img src={logo} alt={alt} />
                        </div>
                        <div className="detail">
                          <strong>{nameLabel}</strong>
                          <p>{form[nameKey] || "-"}</p>
                        </div>
                        <div className="detail">
                          <strong>{handleKey}</strong>
                          {handleKey && <p>{form[handleKey] || "-"}</p>}
                        </div>
                        <div className="detail">
                          <strong>{countLabel}</strong>
                          <p>{form[countKey] || "-"}</p>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
              <div className="note">
                <strong>NOTE:</strong>
                <p>
                  Social Media handle and followers/subscribers count is
                  read-only.
                </p>
              </div>
            </CreatorPlatformsWrapperStyles>
          </div>
        </div>

        {/* ── Right column ── */}
        <div className="row-group">
          <div className="column-group">
            <Select
              id="content_quality"
              label="Content Quality"
              value={form.content_quality || ""}
              onChange={(value) =>
                setForm((prev) => ({ ...prev, content_quality: value }))
              }
              placeholder="Select Content Quality"
              options={contentQualityOptions}
            />

            <label className="hide-profile" htmlFor="hide-profile">
              <SwitchInput
                id="hide-profile"
                checked={form.is_hidden === "Yes"}
                onChange={(e) =>
                  setForm((prev) => ({
                    ...prev,
                    is_hidden: e.target.checked ? "Yes" : "No"
                  }))
                }
              />
              <span>Hide Profile</span>
            </label>
          </div>

          <div className="column-group">
            <Textarea
              id="hidden_reason"
              label="Hidden Reason"
              placeholder="Enter reason to hide profile"
              size="M"
              value={form.hidden_reason || ""}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
    </EditCreatorFormWrapperStyles>
  );
};
